var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "editable",
          rawName: "v-editable",
          value: _vm.blok,
          expression: "blok",
        },
      ],
      staticClass: "blok-button",
      style: _vm.wrapStyles,
    },
    [
      _c(
        "a",
        {
          class: _vm.linkClasses,
          attrs: { "aria-label": _vm.buttonTitle, download: "" },
          on: { click: _vm.downloadButtonClick },
        },
        [_vm._v("\n    " + _vm._s(_vm.buttonTitle) + "\n  ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }